export enum AppFilters {
    clients,
    stores,
    studios,
    cities,
    operations,
    partner,
    loyaltySubscription,
    visits,
}
